import { css } from "@emotion/react"

export const columnContainerStyle = css`
	display: grid;
	grid-template-columns: 1fr 1fr;
	border: 1px solid #e5e6e6;
	border-bottom-color: transparent;
	padding: 16px;
	border-radius: 12px;
`

export const productListStyle = css`
	box-sizing: border-box;
	border-left: 2px solid #e5e7eb;
	padding: 0 0 0 20px;
`

export const pageContainerStyle = css`
	max-height: 676px;

	svg {
		max-height: 676px;
		height: 100%;
	}
`

export const searchBarStyle = css`
	width: 100%;
	border-radius: 0.5em;
	border: 1px solid #66696c;
	background: white;

	.MuiInputBase-root {
		padding-right: 0;
		padding-left: 1em;
	}

	.MuiInputBase-input {
		padding: 7px 10px;
	}
`

export const sortRowStyle = css`
	display: flex;
	align-items: center;
	margin: 10px 0;

	.sort-select-wrapper {
		position: relative;
		display: inline-flex;
		align-items: center;
	}

	select {
		appearance: none;
		-webkit-appearance: none;
		border: none;
		background: transparent;
		font-size: 1rem;
		font-weight: 700;
		color: #111827;
		padding-right: 22px;
		cursor: pointer;
		outline: none;
	}

	.sort-icon {
		position: absolute;
		right: 0;
		pointer-events: none;
		display: flex;
		align-items: center;
	}
`

export const searchIconStyle = css`
	color: #00050a;
	display: flex;
	width: 40px;
	height: 40px;
	padding: 8px;
	padding-top: 6px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	flex-shrink: 0;
	border-left: 1px solid #66696c;
	border-radius: 0;

	& svg {
		width: 1.2rem;
		height: 1.2rem;
		color: #00050a;
	}
`
